module.exports = __webpack_public_path__ + "img/icon-linkedin.98ee0e0b.svg";